import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { API_TEMPLATES_ID_SIMULATE_PATH_KEY } from '@/swagger/constants/surveys-keys';
import { API_POST_TEMPLATE_SIMULATE, KEY_POST_TEMPLATE_SIMULATE } from '../constats';
import { MOCK_RESPONSE_POST_TEMPLATE_SIMULATE } from '../mocks';

type RequestPostTemplateSimulate = GenericPost<
  typeof API_TEMPLATES_ID_SIMULATE_PATH_KEY
>['request']['body'];

type ResponsePostTemplateSimulate = GenericPost<
  typeof API_TEMPLATES_ID_SIMULATE_PATH_KEY
>['response']['body'];

export type CallParamsPostTemplateSimulate = RequestPostTemplateSimulate & {
  templateId: string;
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostTemplateSimulate = ResponsePostTemplateSimulate;

type CallErrorPostTemplateSimulate = GenericApiError;

type CallSelectorsPostTemplateSimulate = unknown;

export const postTemplateSimulateCall = createGeneralCall<
  CallParamsPostTemplateSimulate,
  CallResponsePostTemplateSimulate,
  CallErrorPostTemplateSimulate,
  CallSelectorsPostTemplateSimulate
>({
  id: KEY_POST_TEMPLATE_SIMULATE,
  method: 'post',
  url:
    ({ payload }) =>
    () => {
      return API_POST_TEMPLATE_SIMULATE(payload.templateId);
    },
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_TEMPLATE_SIMULATE
    : undefined,
});
